export class NavigationHistoryService {
  constructor() {
    this.key = "navigationHistory";
    this.init();
  }

  init() {
    if (!sessionStorage.getItem(this.key)) {
      sessionStorage.setItem(this.key, JSON.stringify({
        "client-detail": "/client-info/images"
      }));
    }
  }

  save(section, url) {
    const history = JSON.parse(sessionStorage.getItem(this.key)) || {};
    history[section] = url;
    sessionStorage.setItem(this.key, JSON.stringify(history));
  }

  get(section) {
    const history = JSON.parse(sessionStorage.getItem(this.key)) || {};
    return history[section] || null;
  }

  delete(section) {
    const history = JSON.parse(sessionStorage.getItem(this.key)) || {};
    delete history[section];
    sessionStorage.setItem(this.key, JSON.stringify(history));
  }

  clear() {
    sessionStorage.setItem(this.key, JSON.stringify({}));
  }
}
  